import React from 'react';
import styles from './BlueButton.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const BlueButton = ({type, text, className}) => {
  return (
    <button className={`${cx('BlueButton')} ${className}`} type={type}>{text}</button>
  );
};

export default BlueButton;